export function resolveMediaUrl(url) {
  const original = url;
  const raw = (url ?? '').toString().trim();
  if (!raw) return null;

  if (/^https?:\/\//i.test(raw)) return raw;

  const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').toString().trim().replace(/\/+$/, '');
  const join = (base, path) => {
    const p = (path || '').toString().trim();
    if (!base) return p;
    if (!p) return base;
    if (p.startsWith('/')) return `${base}${p}`;
    return `${base}/${p}`;
  };

  let resolved = raw;
  if (raw.startsWith('/api/uploads/')) {
    resolved = join(backendUrl, raw);
  } else if (raw.startsWith('api/uploads/')) {
    resolved = join(backendUrl, `/${raw}`);
  } else if (raw.startsWith('/')) {
    resolved = join(backendUrl, raw);
  } else if (!raw.includes('/')) {
    resolved = join(backendUrl, `/api/uploads/${raw}`);
  }

  if (process.env.NODE_ENV !== 'production' && resolved !== raw && typeof console !== 'undefined' && typeof console.debug === 'function') {
    console.debug('media url', original, resolved);
  }

  return resolved;
}

export function isVideoUrl(url) {
  return /\.(mp4|webm|ogg|mov|m4v|avi)(\?.*)?$/i.test(url || '');
}
